import { render, staticRenderFns } from "./ClassroomAvailCell.vue?vue&type=template&id=bf77bd3a&scoped=true&"
import script from "./ClassroomAvailCell.vue?vue&type=script&lang=ts&"
export * from "./ClassroomAvailCell.vue?vue&type=script&lang=ts&"
import style0 from "./ClassroomAvailCell.vue?vue&type=style&index=0&id=bf77bd3a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf77bd3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VRow,VTooltip})
